import styled from 'styled-components';

export const FormWrapper = styled.div`
    background: rgba(0, 0, 0, 0.05);
    padding: 20px;
    max-width: 300px;
    margin: 0 auto;
    border: var(--line);
    text-align: center;
`;

export const FormCont = styled.div`
  justify-content: center;
  margin: 20px;
  text-align: center;
`;

export const FormElement = styled.div`
  max-width: 240px;
  margin: 0 auto;
`;

export const FormHeading = styled.h1`
  padding: 6px 0 15px;
`;
export const FormRow = styled.div`
    margin: 10px 0;
    text-align: center;
`;

export const Select = styled.select`
    border: var(--line);
    padding: 5px;
    font-size: 11px;
    width: 100%;
`;

export const Option = styled.option`
    text-align: center;
    font-size: 11px;
    z-index: 150;
`;

export const SelectContainer = styled.div`
    display: flex;
    align-items: center;
    /* justify-content: space-evenly; */
    background: var(--subHeaderBgColor);
    color: var(--subHeaderTextColor);
    text-transform: none;
    font-size: 0.8em;
    width: 100%;
`

export const Label = styled.label`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.8em;
  padding: 0px 5px;
    width: 60px;
    text-align: center;
`;
